<template>
  <div>
    <v-container fluid>
      <!--Title has been changed-->
      <material-card icon="mdi-clipboard-text" inline title="Assigned Bus Route To Student">
        <v-card-actions>
          <router-link :to="{ name: 'assignBusRouteStudent', params: {} }" title="Assign Bus Route To Student">
            <v-btn absolute right top elevation="1" color="primary">
              <v-icon left>mdi-plus</v-icon>
              Assign Bus Route To Student
            </v-btn>
          </router-link>

        </v-card-actions>
        <v-card flat class="px-2">
          <form @submit.prevent="Save">
            <v-row>
             <v-col cols="12" md="6" lg="5">
                <label class="font-weight-medium body-2">Select Vehicle Route <span class="error--text">*</span></label>
                <v-autocomplete class="my-0 py-1" prepend-icon="mdi-account"
                :items="vehicleRouteDetails"
                key="id"
                item-text="routeName"
                item-value="id"
                v-model="VehicleRouteId"
                single-line required
                placeholder="--Select--"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <label class="font-weight-medium body-2">Filter Action</label>

                <div class="inside">
                  <v-btn class="mr-4" color="success" elevation="1" type="submit">
                    <v-icon left> mdi-text-box-check-outline </v-icon>
                    Apply</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </form>
        </v-card>
        <v-card-component>
          <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
            <v-card-title>
              Total Records : {{ total }}
              <v-spacer></v-spacer>
            </v-card-title>
            <v-text-field
              :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search"
              append-icon="mdi-magnify"
              class="ml-auto mb-2"
              label="Search"
              hide-details
              single-line
              style="max-width:350px;"
            />
          </v-card-text>
          <v-divider class=" my-0 " />
          <v-data-table
            :footer-props="{
              'items-per-page-options': [5]
            }"
            :items-per-page="10"
            :headers="headers"
            :items="vehicleRouteAssign"
            :search="search"
          >
            <template v-slot:item.actions="{ item }">
              <router-link :to="{ name: 'editAssignBusRouteStudent', params: { assinedID: item.id } }">
                <v-btn class="px-2 ml-1 ma-1" color="success" min-width="0" small>
                  <v-icon small> mdi-pencil</v-icon>
                </v-btn>
              </router-link>
            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
        </v-card-component>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>

<script>
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import moment from 'moment'
import Utils from '@/utils'
import { mapGetters } from 'vuex'
import _ from 'lodash'
export default {
  name: 'assignBusRouteStudentListing',
  components: {
    MaterialCard,
    VCardComponent
  },
  data () {
    return {
      search: '',
      isLoading: false,
      loadingComponent: null,
      fromDate: moment().format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      maxToDate: moment().format('YYYY-MM-DD'),
      academicYears: [],
      academicYearID: '',
      inProgress: false,
      franchiseeArr: [],
      franchiseeID: '',
      vehicleChallanDocuments: [],
      vehicleRouteDetails: [],
      VehicleRouteId: '',
      vehicleRouteAssign: [],
      total: '',
      headers: [
        { text: 'Vehicle Route', value: 'vehicleBusRoute.routeName', sortable: true },
        { text: 'Vehicle Route Type', value: 'vehicleBusRoute.isPickUp', sortable: true },
        { text: 'Vehicle Route Stop', value: 'vehicleRouteStop.pickUpStop', sortable: true },
        { text: 'Stop Number', value: 'vehicleRouteStop.StopNumber', sortable: true },
        { text: 'Student Name', value: 'studentAdmission.studentEnrollment.studentName', sortable: true },
        { text: 'Pick up Time', value: 'vehicleRouteStop.pickupTime', sortable: true },
        { text: 'Nearest Land Mark', value: 'vehicleRouteStop.nearestLandMark', sortable: true },
        { text: 'Action', value: 'actions', sortable: false, align: 'center' }
      ],
      docsheaders: [
        { text: 'Vehicle Challan Documents', value: 'Vehicle_Documents', sortable: true }
      ]
    }
  },
  async created () {
    await this.getYear()
    await this.getFranchiseeList()
    await this.onFranchiseeChange()
  },
  watch: {
    franchisee: async function () {
      await this.onFranchiseeChange()
    },
    academicYear: async function () {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        await this.getVehicleList()
        this.inProgress = false
      }
    },
    getVehicleList: async function () {
      try {
        this.isLoading = true
        let getParam = {}
        this.vehicleRouteAssign = []
        if (this.franchiseeID.length === 0) {
          this.isLoading = false
          return this.$buefy.toast.open({
            message: 'Please select franchisee',
            type: 'is-danger',
            duration: 4000
          })
        } else {
          getParam.franchiseeID = this.franchiseeID
        }
        getParam.academicYearID = this.academicYearID
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehiclebusroute`, {
          params: getParam
        })
        this.vehicleRouteDetails = data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getYear: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee`)
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    Save: async function () {
      this.vehicleRouteAssign = []
      this.total = ''
      try {
        let getParam = {}
        getParam.busRouteID = this.VehicleRouteId
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicleRouteAssignStudents/vehicleRouteAssignStudents`, {
          params: getParam
        })
        if (data.length === 0) {
          this.$buefy.dialog.alert({
            title: 'No Data',
            message: 'No Data Found',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        } else {
          this.vehicleRouteAssign = data
          this.vehicleRouteAssign = _.sortBy(this.vehicleRouteAssign, 'vehicleRouteStop.StopNumber')
          this.vehicleRouteAssign.forEach(element => {
            element.vehicleBusRoute.isPickUp = element.vehicleBusRoute.isPickUp === true ? 'Pick Up' : 'Drop'
          })
          console.log('this.vehicleRouteAssign', this.vehicleRouteAssign)
          this.total = this.vehicleRouteAssign.length
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Data', errorMessage)
      }
    }
  }
}
</script>
